var Fuse = require('fuse.js'),
    gtm = require('./lib/gtm-events'),
    pjax = require('./lib/pjax');

document.addEventListener('latte:init', init);

function init() {
    var fuzzyElements = document.getElementsByClassName('fuzzy-search-input');    


    //send data to GTM
    var tracker = function (event) {
        gtm.analyticsEvent(event.category, event.action, event.label.toLowerCase());
    };

    if($('.homepage-message-clear').length) {
        offsetTop = $('.page-alert').outerHeight() - 1;
        $('.homepage-message-clear').css({"margin-top":offsetTop+"px"});
    }

    //onselect and click
    $(document).on('click', '.clickItem', function (e) {
        e.preventDefault();
        var course = $(this).attr('data-name');
        url = $(this).attr('data-url');

        if (url.indexOf('practice') !== -1) {
            tracker({
                category: 'Home Page - Search Practice Test',
                action: 'input-click',
                label: course
            });
        } else {
            tracker({
                category: 'Home Page - Search Courses',
                action: 'input-click',
                label: course
            });
        }
        pjax.loadUrl(url, {scrollTo:true}); //will refresh the content container
    });

    function selectFirst(thisInput) {
        if (resultCount >= 1) {
            //1 or more result(s)
            var index = _.findIndex($('#options-' + thisInput.id).children(), function (i, k) {
                return (
                    _.toUpper($(thisInput).val()) === _.toUpper($('#options-' + thisInput.id).children().eq(k).attr('data-name'))
                );
            });
            url = $('#options-' + thisInput.id).children().eq(index === -1 ? 0 : index).attr('data-url');
            if (url.indexOf('practice') !== -1) {
                tracker({
                    category: 'Home Page - Search Practice Test',
                    action: 'input-enter',
                    label: searchText
                });
            } else {
                tracker({
                    category: 'Home Page - Search Courses',
                    action: 'input-enter',
                    label: searchText
                });
            }
            pjax.loadUrl(url, {scrollTo:true}); //will refresh the content container
        } else if (downCount === -1) {
            gtm.analyticsEvent('Home Page - Search Courses', 'No Results', searchText.toLowerCase());
            //more than one result but no selection
            $(thisInput).addClass('error');
        } else if ($(thisInput).val() === '' || $(thisInput).val() === undefined) {
            $(thisInput).addClass('error');
        } else {
            // selection with down arrow
            e.preventDefault();
            url = $('#options-' + thisInput.id).children().eq(downCount).attr('data-url');
            if (url.indexOf('practice') !== -1) {
                tracker({
                    category: 'Home Page - Search Practice Test',
                    action: 'input-enter',
                    label: $(thisInput).val()
                });
            } else {
                tracker({
                    category: 'Home Page - Search Courses',
                    action: 'input-enter',
                    label: $(thisInput).val()
                });
            }
            pjax.loadUrl(url, {scrollTo:true}); //will refresh the content container
        }
    }

    // 1- TOP BILLBOARD //
    var downCount = -1;
    if ($(fuzzyElements).length > 0) {
        for (var i = 0; i < fuzzyElements.length; i++) {
            thisInput = fuzzyElements[i];
            $(thisInput.id).attr('data-downcount', downCount);
            $(thisInput).after(
                '<ul id="options-' + thisInput.id + '" class="searchOptions hidden"></ul>'
            );
        }

        var fuse = new Fuse(list, options);
        var resultCount = 0;

        var sendInputValue = _.debounce(function (searchText) {
            $('.searchOptions').find('.clickItem').remove();
            $('.searchOptions').append('<li class="clickItem" role="button" tabindex="1">' + 'No Results' + '</li>');
            tracker({
                category: 'Home Page - Search Courses',
                action: 'No Results',
                label: searchText
            });
        }, 500);

        $(document).on('keyup', '.fuzzy-search-input', function (e) {
            var thisInput = this;
            downCount = $(this).attr('data-downCount') * 1; //makes it a number
            if ((e.which > 64 && e.which < 91) || e.which === 8 || e.which === 32 || e.which === 229) {
                searchText = $(thisInput).val().replace(/\s/g, ''); //remove all spaces since result from fuzzy search return everything in no space
                var result = fuse.search(searchText);

                if (result.length === 0) {
                    sendInputValue(searchText);
                }

                maxResults = 5; // limit the result to 5 item for now TODO: move this config into prismic
                if (result.length > maxResults) {
                    result.length = maxResults;
                }

                $('#options-' + thisInput.id).text('');
                result.forEach(function (item, index) {
                    var hoverGray = index === 0 ? 'hover' : ''; //append hover gray on first item
                    var searchTextUpper = searchText.toUpperCase();
                    var re = new RegExp(searchTextUpper, 'ig');
                    var foundText = item.title;
                    var keyword = '';

                    if (foundText.search(searchText) === -1) {
                        if (item.tags.length > 1) {
                            keyword = _.filter(item.tags, function (item) {
                                if (searchTextUpper.indexOf(item.toUpperCase()) >= 0) {
                                    return item;
                                }
                            });
                        } else {
                            keyword = item.tags;
                        }
                    } else {
                        keyword = '';
                    }

                    var textIndex = foundText.toUpperCase().indexOf(searchTextUpper);
                    if (textIndex !== -1) {
                        //output to page put strong tag around search term and remove all ®
                        name = [foundText.slice(0, textIndex) + '<strong>' +
                            foundText.slice(textIndex, textIndex + searchText.length) + '</strong>' +
                            foundText.slice(textIndex + searchText.length, foundText.length)].join('').replace(/®/g, '');
                    } else {
                        name = foundText;
                    }

                    if ($(thisInput).hasClass('practice')) {
                        thisURL = item.urlPractice;
                    } else {
                        thisURL = item.url;
                    }

                    //Print LI if url is not blank
                    if (thisURL !== undefined && thisURL !== '') {
                        $('#options-' + thisInput.id).append(
                            '<li class="clickItem ' + hoverGray + '" role="button" tabindex="1" data-name="' +
                            foundText + '" data-tags="' + item.tags + '" data-url="' + thisURL + '">' + name + '</li>'
                        );
                        resultCount = result.length;
                    }
                });

                if (resultCount === 0) {
                    $('#options-' + thisInput.id).addClass('hidden');
                } else {
                    $('#options-' + thisInput.id).removeClass('hidden');
                }
                downCount = -1;
            }

            //handle enter
            if (e.which == 13) {
                e.preventDefault();
                selectFirst(thisInput);
            }

            // handle down arrow key
            if (e.which == 40) {
                if (resultCount >= 1) {
                    e.preventDefault();
                    downCount = downCount + 1;
                    if (downCount === resultCount) {
                        return false;
                    }
                    $(thisInput).val(
                        $('#options-' + thisInput.id).children().eq(downCount).attr('data-name')
                    );
                    $('#options-' + thisInput.id).children().removeClass('hover');
                    $('#options-' + thisInput.id).children().eq(downCount).addClass('hover');
                }
            }

            // handle up arrow key
            if (e.which == 38) {
                if (resultCount >= 1) {
                    e.preventDefault();
                    downCount = downCount - 1;
                    if (downCount === resultCount) {
                        return false;
                    }
                    $(thisInput).val(
                        $('#options-' + thisInput.id).children().eq(downCount).attr('data-name')
                    );
                    $('#options-' + thisInput.id).children().removeClass('hover');
                    $('#options-' + thisInput.id).children().eq(downCount).addClass('hover');
                }
            }

            if ($(thisInput).val() === '') {
                $('#options-' + thisInput.id).addClass('hidden');
                resultCount = 0;
            }

            $(this).attr('data-downCount', downCount);
        });

        // handle button click
        $(document).on('click', '.test-search', function (e) {
            e.preventDefault();
            thisInput = $(this).closest('div').find('.fuzzy-search-input');
            thisInput = thisInput[0];
            selectFirst(thisInput);
        });


        // this replaces blur and timeout function when clicking away from dropdown or input field, doesn't force race between timeout and function completing
        $(document).on('click', function(e) {
            target = e.target;
            if(!$(target).hasClass('fuzzy-search-input') && !$(target).hasClass('searchOptions')) {
                $(".searchOptions").addClass('hidden');
            }
        });

        // when user focuses on input field, it shows up again if there are suggestions based on their current text entry
        $('.fuzzy-search-input').focus(function() {
            if(resultCount >= 1) {
                $(".searchOptions").removeClass('hidden');
            }
        });
    }

    $('.tags').focus(function () {
        $('.tags').removeClass('error');
    });
}



//////////////////
// WEBPACK FOOTER
// ./public/js/homepage.js
// module id = 76
// module chunks = 0